import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";

import { PopoverAnchor } from "./PopoverAnchor";
import { PopoverContent } from "./PopoverContent";
import { PopoverTrigger } from "./PopoverTrigger";

export type PopoverProps = ComponentProps<typeof PopoverPrimitive.Root>;

/**
 * Floating content anchored to a trigger. Compose `Popover.Trigger` and `Popover.Content`; use
 * `Popover.Anchor` to position the content against an element other than the trigger (or a
 * `virtualRef`, e.g. a text caret).
 *
 * @example
 * ```tsx
 * <Popover>
 *   <Popover.Trigger asChild>
 *     <Button variant="outline">Filters</Button>
 *   </Popover.Trigger>
 *   <Popover.Content align="start">…</Popover.Content>
 * </Popover>
 * ```
 */
const PopoverRoot = (props: PopoverProps) => <PopoverPrimitive.Root data-slot="popover" {...props} />;

export const Popover = Object.assign(PopoverRoot, {
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Anchor: PopoverAnchor,
});
